import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const CorrectiveActionsDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_correctiveActions_task_list"
  />
);

export default CorrectiveActionsDefaultWidget;
